import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import ReactSelect from '../../../../../components/ReactSelect';
import Body from '../Body';
import { getQueriesBestWords } from '../query';
import { setDeviceQuery } from '../../../../GSCDataSettings/query';
import ConfirmationModal from '../../../../Settings/ManageAccount/Modal';
import Loading from '../../../../../components/Loading';
import BodyTable from '../Body/bodyTable';
import 'react-tooltip/dist/react-tooltip.css';
import NoDiscover from '../../../noDiscover';
import { isTrue } from '../../../../../helpers/isTrue';

class GoogleSearchConsole extends Component {
    constructor(props) {
        super(props);

        this.showOpened = this.showOpened.bind(this);
        this.onClickOnStep = this.onClickOnStep.bind(this);
        this.onSelectDomain = this.onSelectDomain.bind(this);
        this.getQuestionsBestWords = this.getQuestionsBestWords.bind(this);
        this.onSubmitQuestions = this.onSubmitQuestions.bind(this);
        this.updateConfig = this.updateConfig.bind(this);
        this.onSubmitList = this.onSubmitList.bind(this);
        this.onToggleModal = this.onToggleModal.bind(this);
        this.updateTableData = this.updateTableData.bind(this);
        this.createOptionsList = this.createOptionsList.bind(this);

        this.optionList = this.createOptionsList(this.props.domains);

        this.state = {
            selectedCollapse: 1,
            selectedDomain: '',
            selectedDomainId: '',
            domainLoading: false,
            questions: '',
            best_translation: '',
            words_length: 10,
            questions_data: [],
            best_translation_data: [],
            words_length_data: [],
            isOpenModal: false,
            loaderConfigs: false,
            tableData: {
                questions: {
                    loading: false,
                    data: [],
                    didSearch: false,
                },
                best_translation: {
                    loading: false,
                    data: [],
                    didSearch: false,
                },
                words_length: {
                    loading: false,
                    data: [],
                    didSearch: false,
                },
            },
        };
    }

    createOptionsList(domains) {
        const optionList = domains.map((domain) => ({
            id: domain.id,
            url: domain.url,
            value: domain.id,
            label: (
                <div className="gsc-test-user">
                    <div>{domain.url}</div>
                    {isTrue(window.is_superuser) && (
                        <div>
                            {domain.active ? (
                                <i className="text-success icofont-verification-check"></i>
                            ) : (
                                <i className=" text-danger icofont-ui-close"></i>
                            )}{' '}
                        </div>
                    )}
                </div>
            ),
        }));
        return optionList;
    }

    customFilter(option, inputValue) {
        return option?.data?.url?.toLowerCase()?.includes(inputValue.toLowerCase());
    }

    updateTableData(type, data, loading, didSearch = false) {
        this.setState((prevState) => ({
            tableData: {
                ...prevState.tableData,
                [type]: {
                    data,
                    loading,
                    didSearch,
                },
            },
        }));
    }

    async getQuestionsBestWords(domain_id) {
        try {
            this.setState({
                loaderConfigs: true,
            });
            const res = await getQueriesBestWords(domain_id);
            const data = await res.json();
            this.setState({
                questions: data?.questions?.join(',') ?? '',
                best_translation: data?.best_translation?.join(',') ?? '',
            });
            this.scrollToBottom();
        } catch (err) {
            console.log(err);
        } finally {
            this.setState({
                loaderConfigs: false,
            });
        }
    }

    onClickOnStep(id) {
        this.setState({
            selectedCollapse: id,
        });
    }

    showOpened(name, value) {
        return this.state.selectedCollapse === name ? value ?? 'active' : '';
    }

    async onSelectDomain(data) {
        try {
            this.setState({
                selectedDomain: data.url,
                selectedDomainId: data.id,
                domainLoading: true,
            });
            this.getQuestionsBestWords(data.id);
        } catch (err) {
            console.log(err);
        } finally {
            this.setState({
                domainLoading: false,
            });
        }
    }

    async updateConfig(body) {
        try {
            const response = await setDeviceQuery(body);
            const data = await response.json();
        } catch (err) {
            console.log(err);
        }
    }

    onSubmitQuestions() {
        const body = {
            questions: this.state.questions,
            domain_url: this.state.selectedDomain,
        };
        this.updateConfig(body);
    }

    onSubmitList() {
        const body = {
            best_translation: this.state.best_translation,
            domain_url: this.state.selectedDomain,
        };
        this.updateConfig(body);
    }

    onToggleModal() {
        this.setState({
            isOpenModal: !this.state.isOpenModal,
        });
    }

    scrollToBottom() {
        setTimeout(() => {
            window.scrollTo(0, document.body.scrollHeight);
        }, 100);
    }

    render() {
        const { t } = this.props;
        this.optionList = this.createOptionsList(this.props.domains);
        if (this.props.no_discover_account) {
            return <NoDiscover />;
        }
        return (
            <>
                <div className="google-search-console-component-box">
                    {this.props.linkedAccounts?.length === 0 ? (
                        <div className="card">
                            <div className="card-body">
                                <div className="ai-tracking-no-linked-accounts">
                                    <div className="ai-tracking-no-linked-accounts-header">
                                        {t('ai_tracking.global.linked_accounts')}
                                    </div>
                                    <div className="ai-tracking-no-linked-accounts-subheader">
                                        {t('settings.linked_accounts.no_linked_accounts')}
                                    </div>
                                    <div className="d-flex justify-content-end mt-16">
                                        <button
                                            onClick={this.onToggleModal}
                                            className="button button-filled button-primary"
                                        >
                                            {t('settings.linked_accounts.add_account')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="card">
                                <div className="card-body">
                                    <div className="prompt-generator-title">
                                        <div className="prompt-generator-number">1</div>
                                        <div className="prompt-generator-label">
                                            {t(
                                                'ai_tracking.prompt_generator.googleSearchConsole.selectDomain',
                                            )}
                                        </div>
                                    </div>
                                    <div className="mt-15">
                                        <ReactSelect
                                            options={this.optionList}
                                            value={this.optionList.find(
                                                (x) => x.id === this.state.selectedDomainId,
                                            )}
                                            labelClassname={'ai-tracking-create-label'}
                                            label={
                                                <div>
                                                    {t('ai_tracking.global.domain')}{' '}
                                                    <span className="text-danger">*</span>
                                                </div>
                                            }
                                            customeOnChange={this.onSelectDomain}
                                            blurInputOnSelect={true}
                                            classname="mb-10"
                                            disabled={this.state.domainLoading}
                                            components={{
                                                IndicatorSeparator: () => null,
                                            }}
                                            customFilter={this.customFilter}
                                        />
                                    </div>
                                    {this.state.domainLoading && <Loading />}

                                    {this.state.selectedDomainId && (
                                        <div className="prompt-generator-body-box ai-tracking-gsc-box">
                                            <div className="prompt-generator-body-box-header">
                                                <button
                                                    className={`generator-item ${this.showOpened(
                                                        1,
                                                    )}`}
                                                    onClick={() => this.onClickOnStep(1)}
                                                    disabled={this.state.domainLoading}
                                                >
                                                    <img
                                                        src="/static/img/prompt-generator-questions.svg"
                                                        alt="icon"
                                                    />
                                                    {t('ai_tracking.prompt_generator.questions')}
                                                </button>
                                                <button
                                                    className={`generator-item ${this.showOpened(
                                                        2,
                                                    )}`}
                                                    onClick={() => this.onClickOnStep(2)}
                                                    disabled={this.state.domainLoading}
                                                >
                                                    <img
                                                        src="/static/img/prompt-generator-lists.svg"
                                                        alt="icon"
                                                    />
                                                    {t('ai_tracking.prompt_generator.list')}
                                                </button>
                                                <button
                                                    className={`generator-item ${this.showOpened(
                                                        3,
                                                    )}`}
                                                    onClick={() => this.onClickOnStep(3)}
                                                    disabled={this.state.domainLoading}
                                                >
                                                    <img
                                                        src="/static/img/prompt-generator-long-queries.svg"
                                                        alt="icon"
                                                    />
                                                    {t('ai_tracking.prompt_generator.long_queries')}
                                                </button>
                                                <button
                                                    className={`generator-item ${this.showOpened(
                                                        4,
                                                    )}`}
                                                    onClick={() => this.onClickOnStep(4)}
                                                    disabled={this.state.domainLoading}
                                                >
                                                    <img
                                                        src="/static/img/prompt-generator-all.svg"
                                                        alt="icon"
                                                    />
                                                    {t('ai_tracking.prompt_generator.all')}
                                                </button>
                                            </div>
                                            <div
                                                className={`prompt-generator-body-box-body ${this.showOpened(
                                                    1,
                                                )}`}
                                            >
                                                <Body
                                                    inputData={this.state.questions}
                                                    selectedDomain={this.state.selectedDomain}
                                                    selectedDomainId={this.state.selectedDomainId}
                                                    onSubmit={this.onSubmitQuestions}
                                                    inputDisabled={this.state.domainLoading}
                                                    loaderConfigs={this.state.loaderConfigs}
                                                    expression={`"^(${this.state.questions.replace(
                                                        /,/g,
                                                        '|',
                                                    )})"`}
                                                    onChangeInput={(e) =>
                                                        this.setState({ questions: e.target.value })
                                                    }
                                                    inputLabel={t(
                                                        'ai_tracking.prompt_generator.question_label',
                                                    )}
                                                    buttonLabel={t(
                                                        'ai_tracking.prompt_generator.googleSearchConsole.get_questions',
                                                    )}
                                                    updateTableData={(data, loading, didSearch) =>
                                                        this.updateTableData(
                                                            'questions',
                                                            data,
                                                            loading,
                                                            didSearch,
                                                        )
                                                    }
                                                    promptCredits={this.props.promptCredits}
                                                    getCreditsLoader={this.props.getCreditsLoader}
                                                />
                                            </div>
                                            <div
                                                className={`prompt-generator-body-box-body ${this.showOpened(
                                                    2,
                                                )}`}
                                            >
                                                <Body
                                                    inputData={this.state.best_translation}
                                                    selectedDomain={this.state.selectedDomain}
                                                    selectedDomainId={this.state.selectedDomainId}
                                                    expression={`"^(${this.state.best_translation.replace(
                                                        /,/g,
                                                        '|',
                                                    )})"`}
                                                    loaderConfigs={this.state.loaderConfigs}
                                                    inputDisabled={this.state.domainLoading}
                                                    onChangeInput={(e) =>
                                                        this.setState({
                                                            best_translation: e.target.value,
                                                        })
                                                    }
                                                    onSubmit={this.onSubmitList}
                                                    inputLabel={t(
                                                        'ai_tracking.prompt_generator.list_label',
                                                    )}
                                                    buttonLabel={t(
                                                        'ai_tracking.prompt_generator.googleSearchConsole.get_questions',
                                                    )}
                                                    updateTableData={(data, loading, didSearch) =>
                                                        this.updateTableData(
                                                            'best_translation',
                                                            data,
                                                            loading,
                                                            didSearch,
                                                        )
                                                    }
                                                    promptCredits={this.props.promptCredits}
                                                    getCreditsLoader={this.props.getCreditsLoader}
                                                />
                                            </div>
                                            <div
                                                className={`prompt-generator-body-box-body ${this.showOpened(
                                                    3,
                                                )}`}
                                            >
                                                <Body
                                                    inputData={this.state.words_length}
                                                    selectedDomain={this.state.selectedDomain}
                                                    selectedDomainId={this.state.selectedDomainId}
                                                    expression={`"^(\\\\S+\\\\s+){${this.state.words_length},}\\\\S+$"`}
                                                    onChangeInput={(e) =>
                                                        this.setState({
                                                            words_length: e.target.value,
                                                        })
                                                    }
                                                    loaderConfigs={this.state.loaderConfigs}
                                                    buttonLabel={'Get Queries'}
                                                    inputDisabled={this.state.domainLoading}
                                                    inputLabel={t(
                                                        'ai_tracking.prompt_generator.long_queries_label',
                                                    )}
                                                    dontShowHint
                                                    updateTableData={(data, loading, didSearch) =>
                                                        this.updateTableData(
                                                            'words_length',
                                                            data,
                                                            loading,
                                                            didSearch,
                                                        )
                                                    }
                                                    promptCredits={this.props.promptCredits}
                                                    getCreditsLoader={this.props.getCreditsLoader}
                                                />
                                            </div>
                                            {this.showOpened(4) && (
                                                <div
                                                    className={`prompt-generator-body-box-body hide-border ${this.showOpened(
                                                        4,
                                                    )}`}
                                                >
                                                    <Body
                                                        selectedDomain={this.state.selectedDomain}
                                                        selectedDomainId={
                                                            this.state.selectedDomainId
                                                        }
                                                        all
                                                        dontShowHint
                                                        data={this.state.tableData?.all?.data}
                                                        updateTableData={(
                                                            data,
                                                            loading,
                                                            didSearch,
                                                        ) =>
                                                            this.updateTableData(
                                                                'all',
                                                                data,
                                                                loading,
                                                                didSearch,
                                                            )
                                                        }
                                                        promptCredits={this.props.promptCredits}
                                                        getCreditsLoader={
                                                            this.props.getCreditsLoader
                                                        }
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {(this.state.tableData?.questions?.loading ||
                                this.state.tableData?.questions?.didSearch) &&
                                this.state.selectedDomainId && (
                                    <div
                                        className={`card prompt-generator-table ${this.showOpened(
                                            1,
                                        )}`}
                                    >
                                        <div className="card-body">
                                            <div className="prompt-generator-title">
                                                <div className="prompt-generator-number">2</div>
                                                <div className="prompt-generator-label">
                                                    {t(
                                                        'ai_tracking.prompt_generator.googleSearchConsole.select_questions_header',
                                                    )}
                                                </div>
                                            </div>
                                            <div className="ai-tracking-gsc-box">
                                                <div>
                                                    <BodyTable
                                                        data={this.state.tableData.questions.data}
                                                        loading={
                                                            this.state.tableData.questions.loading
                                                        }
                                                        available_credits={
                                                            this.props.available_credits
                                                        }
                                                        balanceLoader={this.props.balanceLoader}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            {(this.state.tableData?.best_translation?.loading ||
                                this.state.tableData?.best_translation?.didSearch) &&
                                this.state.selectedDomainId && (
                                    <div
                                        className={`card prompt-generator-table ${this.showOpened(
                                            2,
                                        )}`}
                                    >
                                        <div className="card-body">
                                            <div className="prompt-generator-title">
                                                <div className="prompt-generator-number">2</div>
                                                <div className="prompt-generator-label">
                                                    {t(
                                                        'ai_tracking.prompt_generator.googleSearchConsole.select_questions_header',
                                                    )}
                                                </div>
                                            </div>
                                            <div className="ai-tracking-gsc-box">
                                                <div>
                                                    <BodyTable
                                                        data={
                                                            this.state.tableData.best_translation
                                                                .data
                                                        }
                                                        loading={
                                                            this.state.tableData.best_translation
                                                                .loading
                                                        }
                                                        available_credits={
                                                            this.props.available_credits
                                                        }
                                                        balanceLoader={this.props.balanceLoader}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            {(this.state.tableData?.words_length?.loading ||
                                this.state.tableData?.words_length?.didSearch) &&
                                this.state.selectedDomainId && (
                                    <div
                                        className={`card prompt-generator-table ${this.showOpened(
                                            3,
                                        )}`}
                                    >
                                        <div className="card-body">
                                            <div className="prompt-generator-title">
                                                <div className="prompt-generator-number">2</div>
                                                <div className="prompt-generator-label">
                                                    {t(
                                                        'ai_tracking.prompt_generator.googleSearchConsole.select_questions_header',
                                                    )}
                                                </div>
                                            </div>
                                            <div className="ai-tracking-gsc-box">
                                                <div>
                                                    <BodyTable
                                                        data={
                                                            this.state.tableData?.words_length?.data
                                                        }
                                                        loading={
                                                            this.state.tableData?.words_length
                                                                ?.loading
                                                        }
                                                        available_credits={
                                                            this.props.available_credits
                                                        }
                                                        balanceLoader={this.props.balanceLoader}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            {(this.state.tableData?.all?.loading ||
                                this.state.tableData?.all?.didSearch) &&
                                this.state.selectedDomainId && (
                                    <div
                                        className={`card prompt-generator-table ${this.showOpened(
                                            4,
                                        )}`}
                                    >
                                        <div className="card-body">
                                            <div className="prompt-generator-title">
                                                <div className="prompt-generator-number">2</div>
                                                <div className="prompt-generator-label">
                                                    {t(
                                                        'ai_tracking.prompt_generator.googleSearchConsole.select_questions_header',
                                                    )}
                                                </div>
                                            </div>
                                            <div className="ai-tracking-gsc-box">
                                                <div>
                                                    <BodyTable
                                                        data={this.state.tableData?.all?.data}
                                                        loading={this.state.tableData?.all?.loading}
                                                        available_credits={
                                                            this.props.available_credits
                                                        }
                                                        balanceLoader={this.props.balanceLoader}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                        </>
                    )}
                    <ConfirmationModal
                        isOpen={this.state.isOpenModal}
                        onClose={this.onToggleModal}
                    />
                </div>
            </>
        );
    }
}

export default withTranslation()(GoogleSearchConsole);
